/*
 * @Author: miroku.yang
 * @Date: 2023-12-30 12:13:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-03-20 15:03:10
 * @Description:
 */
import { useEffect, useState } from 'react'
import { Button } from 'antd'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'next/router'
import dayjs from 'dayjs'
import { useTranslation, Trans } from '@/libs/next-lang'
import { formatUserInfo } from '@/utils'
import IconSvg from '@/components/IconSvg'
import eventBus from '@/utils/eventBus'
import globalStore from '@/globalStore'
import { setStorage } from '@/utils/storage'
import { EVENT_NAME } from '@/components/ProbationaryMemberArea'
import { getMemberTria } from '@/components/ProbationaryMemberArea/services'
import styles from './index.module.less'

function Body({ onClose }: any) {
  const router = useRouter()
  const [dateString, setDateString] = useState<any>('') // 会员领取日期
  const { t } = useTranslation(['components'])

  useEffect(() => {
    async function init() {
      const { data }: any = await getMemberTria()
      if (data?.code === 0) {
        const userInfo: any = formatUserInfo(data?.result)
        setStorage('user', userInfo)
        const end = dayjs(dayjs(userInfo.expireTime).format('YYYY-MM-DD'))
        const start = dayjs(dayjs(dayjs().valueOf()).format('YYYY-MM-DD'))
        const day = end.diff(start, 'days')
        setDateString(day || '')
        // 更新会员信息
        globalStore.updateUserInfo(userInfo)
        eventBus.emit(EVENT_NAME.FIRST_CLAIM)
      }
    }
    init()
  }, [])

  return (
    <div className={styles['content-wrapper']}>
      <div className="success-result" style={{ textAlign: 'center', marginTop: 57 }}>
        <div style={{ marginBottom: 12 }}>
          <IconSvg type="icon-chenggong2" />
          <span className="ml-5" style={{ fontSize: 18 }}>
            <Trans i18nKey="t96" ns="components" dateString={dateString}>
              {{ dateString }}天会员领取成功
            </Trans>
          </span>
        </div>
        {/* <div className="ml-5 free-tip">尽享全场模板免费制作、下载、分发</div>
        <div>
          <Steps current={0} progressDot>
            <Step
              title={<span style={{ fontSize: 16, color: '#FFFFFF' }}>新用户注册</span>}
              description={
                <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)' }}>14天会员</span>
              }
            />
            <Step
              title={<span style={{ fontSize: 16, color: '#FFFFFF' }}>完成20个模板作品</span>}
              description={
                <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)' }}>
                  可升级至28天会员
                </span>
              }
            />
          </Steps>
        </div> */}
      </div>
      <Button
        block
        className="confirm-btn"
        onClick={() => {
          onClose?.()
          if (!['/inspiration/template', '/inspiration/case'].includes(router.pathname)) {
            router.push('/inspiration/template')
          }
        }}
      >
        {t('components:t87')}
      </Button>
    </div>
  )
}

export default observer(Body)
